import {post} from './base.service'
export default{
    /* 天府通办/天府蓉易办APP登录获取健康彭州的tokenId */
    loginByRybUser(params){
        return post('/app/ryb/user/loginByRybUser', params)
    }
}



// WEBPACK FOOTER //
// ./src/service/tfy.service.js